import type { BtlApplication } from 'api/btlApplicationForm/types';
import type { OoCaseSidebarContext } from 'components/CaseSidebar/buildOoCaseSidebar';
import { useSearchParams } from 'react-router-dom';
import { CaseApplicantIndividualPage } from './CaseApplicantIndividualPage';
import { CaseApplicantsList } from './CaseApplicantsList';

interface CaseApplicantsPageProps {
  case?: BtlApplication;
  isCaseLoading: boolean;
  sidebarContext: OoCaseSidebarContext;
}

export function CaseApplicantsPage({ case: caseData, isCaseLoading, sidebarContext }: CaseApplicantsPageProps) {
  const [searchParams] = useSearchParams();
  const individualId = searchParams.get('individualId');

  if (individualId) {
    return (
      <CaseApplicantIndividualPage
        case={caseData}
        isCaseLoading={isCaseLoading}
        individualId={individualId}
        sidebarContext={sidebarContext}
      />
    );
  }

  return <CaseApplicantsList case={caseData} isCaseLoading={isCaseLoading} sidebarContext={sidebarContext} />;
}
